export const EventResourceBundle = {
  placeholders: {
    city: "You are in..",
    eventType: "And you like?",
    date: "Find a date",
  },
};
